<template>
  <v-row class="py-5 d-flex d-md-none">
    <v-col
      cols="12"
      sm="6"
      class="d-flex d-md-none pb-5 pr-sm-5"
      v-if="canSeeRequestEndorsement"
    >
      <BaseButton
        width="100%"
        outlined
        color="secondary"
        v-html="'SOLICITAR ENDOSSO'"
      />
    </v-col>
    <v-col
      cols="12"
      sm="6"
      class="d-flex d-md-none"
      v-if="canSeeNewEndorsement"
    >
      <BaseButton class="secondary white--text justify-start" width="100%">
        <v-icon class="pr-9">
          fa-plus
        </v-icon>
        NOVO ENDOSSO
      </BaseButton>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    canSeeRequestEndorsement: {
      type: Boolean,
      default: true
    },
    canSeeNewEndorsement: {
      type: Boolean,
      default: true
    }
  }
};
</script>
